import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer1PrzygotowanieDokumentacji() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/przygotowanie-dokumentacji-Duzy.jpeg"
          alt="Przygotowanie dokumentacji - ekspertyzy i opinie dendrologiczne - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Wnioski o zezwolenie na wycinkę drzew dokumentacja Gdańsk, Gdynia
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Załatwiamy formalności urzędowe przed czyszczeniem działki
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Wycinka drzew pod budowę na terenie Gdańska, Gdyni, Wejherowa czy Kartuz często wymaga uprzedniego uzyskania decyzji administracyjnej. DRZEWUS bierze na siebie kompleksowe przygotowanie dokumentacji, wniosków oraz map działek do urzędów w województwie pomorskim. Dzięki naszej pomocy prawnej i dendrologicznej legalnie przeprowadzisz <a href="/oczyszczanie-terenu/karczowanie-drzew" className="underline hover:opacity-80">karczowanie działki</a> oraz <a href="/oczyszczanie-terenu/wycinka-drzew" className="underline hover:opacity-80">wycinkę drzew</a> bez ryzyka kar.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Przygotowanie dokumentacji do wycinki drzew
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Procedura przy wycince drzew
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie złożyć wniosek o zezwolenie na wycięcie drzewa
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Przygotowanie dokumentacji do wycinki drzew</h2>
          <p>
            Do wycięcia niektórych drzew i krzewów potrzebujesz pozwolenia.
            Zanim zdecydujesz się na całkowite usunięcie drzewa{" "}
            <strong>musisz złożyć wniosek</strong> do urzędu gminy lub urzędu
            miasta. Przygotowanie wniosku o zezwolenie na usunięcie drzew wymaga
            nieco wysiłku. <strong>Możesz zlecić to nam</strong>. Jesteśmy
            ekspertami od wycinki drzew, a ponieważ działamy kompleksowo, to
            <strong>pomożemy Ci uzyskać zezwolenie na wycinkę</strong>.
          </p>
          <h2 id="2">Procedura przy wycince drzew</h2>
          <p>
            We wniosku o wydanie zezwolenia musisz podać kilka ważnych
            informacji. Jedną z nich jest obwód pnia na wysokości 5 cm od ziemi.
            Jeśli jest on mniejszy od wartości wskazanych w przepisach, to nie
            potrzebujesz zezwolenia.
          </p>
          <p>
            Ale nie musisz się zastanawiać czy ten gatunek drzewa, który rośnie
            na Twojej działce wymaga specjalnej procedury, czy nie. Jeśli
            zatrudnisz nas do tego zadania to{" "}
            <strong>
              sprawdzimy za Ciebie które drzewa wymagają pozwolenia i zgłoszenia
            </strong>
            , a które nie.
          </p>
          <p>
            W przypadku krzewów trzeba podać wielkość powierzchni jaką zajmują.
            Dla krzewów rosnących w skupisku o powierzchni mniejszej niż 25m2
            pozwolenie nie jest potrzebne. Pamiętaj, że drzewa i krzewy możesz
            usunąć dopiero po uzyskaniu pozwolenia. Jeśli nie chcesz męczyć się
            z papierkową robotą, to{" "}
            <strong>
              całą dokumentację potrzebną do wycinki możemy przygotować za
              Ciebie
            </strong>
            . Może się zdarzyć, że do wydania pozwolenia będzie potrzebna opinia
            dendrologa lub ornitologa. Ale nie musisz się tym martwić. W naszej
            ekipie mamy takich specjalistów.
          </p>
          <p>
            Grubość pnia, przy której jako właściciel nieruchomości możesz
            wyciąć drzewo bez zezwolenia, zależy od gatunków drzew, które rosną
            na Twojej działce. Jeśli drzewa mają większy obwód, to przygotuj się
            na złożenie wniosku na wycinkę. Musisz w nim wpisać obwód pnia
            mierzony na wysokości 130 cm. Na tej podstawie urząd wyliczy Ci
            stawkę opłaty za usunięcie drzewa. Jednak nie musisz robić tego
            samodzielnie. Możemy Cię w tym wyręczyć.{" "}
            <strong>
              Zmierzymy wszystko co jest potrzebne, a także wypełnimy wniosek.
            </strong>
          </p>
          <h2 id="3">Gdzie złożyć wniosek o zezwolenie na wycięcie drzewa</h2>
          <p>
            Taki wniosek składasz do swojego urzędu gminy, a jeśli mieszkasz w
            mieście, to do urzędu miasta. Pozwolenie wydaje wójt, burmistrz lub
            prezydent miasta. Sam wniosek może zawierać sporo załączników, w tym
            mapki, oświadczenia i zgody innych osób.{" "}
            <strong>Możemy Cię wyręczyć w całej tej procedurze</strong>. Dla nas
            nie ma rzeczy niemożliwych.{" "}
            <strong>
              Zrobimy wszystko, co w naszej mocy, żebyś mógł otrzymać zezwolenie
              na wycinkę.
            </strong>{" "}
            Nam, tak samo jak Tobie, zależy na tym, żeby zbędne drzewa zniknęły
            z Twojej posesji.
          </p>
          <p>
            Drzewa możesz usunąć od razu po otrzymaniu zezwolenia. Wystarczy, że
            zlecisz to nam. <strong>Jesteśmy do Twojej dyspozycji</strong>. Nasi
            drwale wycieli setki drzew, więc znają się na swojej robocie.
          </p>
          <p>
            Natomiast jeśli urząd nakaże Ci wykonać nasadzenia zastępcze lub
            zarządzi przesadzenie drzew lub krzewów, to również{" "}
            <strong>możesz liczyć na naszą pomoc</strong>. Zajmiemy się
            wszystkim, co potrzebne, żeby cały proces przebiegł zgodnie z
            wymaganiami prawa.
          </p>
          <p>Terenami zielonymi zajmujemy się kompleksowo:</p>
          <ul>
            <li>przygotowujemy całą dokumentację potrzebną do wycinki,</li>
            <li>usuwamy i karczujemy drzewa oraz krzewy,</li>
            <li>niwelujemy nierówności terenu,</li>
            <li>zakładamy trawniki i ogrody,</li>
            <li>wykonujemy nawodnienie.</li>
          </ul>
          <p>
            Jeśli chcesz skorzystać z naszej pomocy przy załatwieniu pozwolenia
            na wycinkę drzew to wypełnij formularz. W ten sposób skontaktujesz
            się też z nami, jeśli potrzebujesz innych usług związanych z Twoim
            ogrodem, działką i terenami zielonymi.{" "}
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-24">
          <div className="flex flex-col items-start justify-start gap-2 w-full">
            {" "}
            <h2 className="uppercase color-yellow text-xl">Nasze realizacje</h2>
            <h3 className="text-3xl lg:text-5xl color-green text-left">
              Spójrz jak pomogliśmy<br></br>
              <span className="color-yellow">naszym Klientom</span>
            </h3>
          </div>
          <div className="flex flex-col items-start justify-center w-full lg:w-2/3">
            <p className="text-gray-600 text-left">
              Zapoznaj się z naszymi dotychczasowymi projektami przygotowania dokumentacji oraz inwentaryzacji dendrologicznych. Kompleksowo wspieramy cały proces urzędowy oraz późniejsze prace terenowe.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-1.jpg"
              alt="Przygotowanie dokumentacji - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-3">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-2.jpg"
              alt="Przygotowanie dokumentacji - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Przygotowanie dokumentacji - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-4.jpg"
              alt="Przygotowanie dokumentacji - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-1.jpg"
              alt="Przygotowanie dokumentacji - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
      {/* <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-1.png"
              alt="Portfolio Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-2.png"
              alt="Portfolio Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-3.png"
              alt="Portfolio Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Portfolio Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-5.png"
              alt="Portfolio Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-6.png"
              alt="Portfolio Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Offer1PrzygotowanieDokumentacji;
